var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToggleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00515 4.65906L10.98 8.63393L10.2729 9.34104L7.00515 6.07327L3.73738 9.34104L3.03027 8.63393L7.00515 4.65906Z",
    fill: "white",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleArrow);
export default __webpack_public_path__ + "static/media/icon-toggle-arrow.c0c1c98fa9168399e9e96a2a6a2436d0.svg";
export { ForwardRef as ReactComponent };